/**
 * Make sure you have the following import
 * <script data-app-key="j0ljsiidl5jokcn" id="dropboxjs" src="https://www.dropbox.com/static/api/1/dropbox.js" type="text/javascript"></script>
 */

app.registerConstructor("DropboxStorage", function () {
	const self = this;

	this.chooseFile = function () {
		Dropbox.choose({linkType: "direct", multiselect: "false", success: self.success});
	};

	this.success = function (filesInResponse) {
		if (!filesInResponse || filesInResponse.length === 0) return;
		const files = _.map(filesInResponse, f => ({
			"name": f.name,
			"source": "DROPBOX",
			"downloadLink": f.link
		}));
		console.log("Dropbox file picked:");
		console.log(files);
		app.vm.SocialStorageCommon.doRemoteRetrieveFile(files, remoteOnSocialStorageChosen)
	};

}).createVM();
